import { useEffect, useState } from "react";

export default function StatCard({
  icon,
  label,
  value,
  subtext,
  tone,
  animate,
  onClick,
  tooltip,
}) {
  const normalizedValue =
    value == null || value === "" ? "--" : value;
  const [displayValue, setDisplayValue] = useState(
    animate && typeof normalizedValue === "number" ? 0 : normalizedValue,
  );

  useEffect(() => {
    if (!animate || typeof normalizedValue !== "number") {
      setDisplayValue(normalizedValue);
      return undefined;
    }

    let frameId = 0;
    const start = performance.now();
    const duration = 800;

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - progress) ** 3;
      setDisplayValue(Math.round(normalizedValue * eased));

      if (progress < 1) {
        frameId = window.requestAnimationFrame(tick);
      }
    };

    frameId = window.requestAnimationFrame(tick);

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [animate, normalizedValue]);

  const renderedValue =
    typeof displayValue === "number"
      ? displayValue.toLocaleString()
      : displayValue ?? "--";

  const Component = onClick ? "button" : "div";

  return (
    <Component
      type={onClick ? "button" : undefined}
      className={`stat-card ${onClick ? "stat-card-clickable" : ""}`.trim()}
      onClick={onClick}
      title={tooltip}
    >
      <div className={`stat-icon ${tone}`.trim()}>{icon}</div>
      <div className="stat-body">
        <div className="stat-label">{label}</div>
        <div className="stat-value">{renderedValue}</div>
        <div className="stat-delta">{subtext || "No data yet"}</div>
      </div>
    </Component>
  );
}
